import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {NextVisitReminderService} from "../../providers/next-visit-reminder.service";
import {NextVisitReminder} from "../../models/next-visit-reminder.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicData} from "../../models/vet-clinic-data.model";
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Subscription} from "rxjs";
import {NextVisitReminderSettingsService} from "../../providers/next-visit-reminder-settings.service";
import {NextVisitReminderSettings} from "../../models/next-visit-reminder-settings.model";
import {ModalController, PopoverController} from "@ionic/angular";
import {
  NextVisitReminderVisitTypeComponent
} from "../next-visit-reminder-visit-type/next-visit-reminder-visit-type.component";
import {
  DataGridActionButtonsMenuComponent
} from "../data-grid/data-grid-action-buttons-menu/data-grid-action-buttons-menu.component";
import {DataGridActionButtonDef} from "../../models/data-grid-action-button-def.model";
import {UserService} from "../../providers/user.service";
import {User} from "../../models/user.model";
import {VetClinic} from "../../models/vet-clinic.model";

@Component({
  selector: 'app-reminders-for-user',
  templateUrl: './reminders-for-user.component.html',
  styleUrls: ['./reminders-for-user.component.scss'],
})
export class RemindersForUserComponent implements OnInit, OnDestroy {

  @Input() nextVisitReminders: NextVisitReminder[];
  @Input() vetcodeId: number;
  @Input() userUUID: string;
  @Input() clinic: VetClinic;
  @Input() clinicWithFullName: boolean;
  @Output() actionCanceledEmitter = new EventEmitter<boolean>();
  reminderToEdit: NextVisitReminder;
  vetClinicStartContext: VetClinicStartContextData;
  clinicData: VetClinicData;
  typeOfEdit = 'users';
  reminderIsValid: boolean = true;
  nextVisitReminderSettings: NextVisitReminderSettings;
  subscriptions: Subscription = new Subscription();
  isBusy: boolean;
  actionButtonsDef: DataGridActionButtonDef[];
  loggedUser: User;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  isGeneralClientAdmin: boolean;


  constructor(private commonUtils: CommonUtils,
              private nextVisitReminderService: NextVisitReminderService,
              private appStateService: AppStateService,
              private vetClinicService: VetClinicService,
              private nextVisitReminderSettingsService: NextVisitReminderSettingsService,
              private modalController: ModalController,
              private popoverController: PopoverController,
              private userService: UserService
  ) {
  }

  ngOnInit() {
    this.registerSubscription( this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    }));
    this.actionButtonsDef = [
      new DataGridActionButtonDef(
        'Edytuj zaleconą wizytę',
        'primary',
        (nextVisitReminder) => {
          if (nextVisitReminder) {
            this.edit(nextVisitReminder);

          }
        }, () => {
        }, (nextVisitReminder) => {
          if (nextVisitReminder) {
            return true;
          } else {
            return false;
          }
        }, true
      ),
      new DataGridActionButtonDef(
        'Powiel zaleconą wizytę',
        'primary',
        (nextVisitReminder) => {
          if (nextVisitReminder) {
            this.duplicate(nextVisitReminder);

          }
        }, () => {
        }, (nextVisitReminder) => {
          if (nextVisitReminder) {
            return true;
          } else {
            return false;
          }
        }, true
      ),
      new DataGridActionButtonDef(
        'Usuń zaleconą wizytę',
        'danger',
        (nextVisitReminder) => {
          if (nextVisitReminder) {
            this.delete(nextVisitReminder);

          }
        }, () => {
        }, (nextVisitReminder) => {
          if (nextVisitReminder) {
            return true;
          } else {
            return false;
          }
        }, true
      )];

    this.appStateService.updateIsBusySubject(true);
    this.registerSubscription(this.vetClinicService.vetClinicData(this.vetcodeId).subscribe(e => {
      this.clinicData = e;
      this.registerSubscription(this.vetClinicService.getVetClinicStartContextData().subscribe((vetClinicStartContext) => {
        this.vetClinicStartContext = vetClinicStartContext;
        this.registerSubscription(this.nextVisitReminderSettingsService.getNextVisitReminderSettingsByVetcode(this.vetcodeId).subscribe((nextVisitReminderSettings) => {
          this.nextVisitReminderSettings = nextVisitReminderSettings;
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }, error => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }

  private getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }


  getNextVisitRemindersScheduled() {
    return this.nextVisitReminders?.filter(e => e.scheduledFirstMessage && !e.sendFirstMessage && !e.deleted && !e.isPhoneNeeded).sort((a,b)=> {
      return this.getTime(new Date(b.created)) - this.getTime(new Date(a.created));
    });
  }

  getNextVisitReminderProceeded() {
    return this.nextVisitReminders?.filter(e => e.sendFirstMessage && !e.deleted && !e.isPhoneNeeded).sort((a,b)=> {
      return this.getTime(new Date(b.sendFirstMessage)) - this.getTime(new Date(a.sendFirstMessage));
    });
  }

  getNextVisitRemindersDeleted() {
    return this.nextVisitReminders?.filter(e => e.deleted && !e.isPhoneNeeded).sort((a,b)=> {
      return this.getTime(new Date(b.deleted)) - this.getTime(new Date(a.deleted));
    });
  }

  exit() {
    this.actionCanceledEmitter.emit(true);
  }


 async edit(reminder: NextVisitReminder) {
   console.log(reminder);

    const modal = await this.modalController.create({
      component: NextVisitReminderVisitTypeComponent,
      componentProps: {
        type: this.typeOfEdit,
        vetClinicStartContext: this.vetClinicStartContext,
        nextVisitReminder: {...reminder},
        clinicData: {...this.clinicData},
        nextVisitReminderSettings: this.nextVisitReminderSettings,
        title: 'Edytuj zaleconą wizytę'
      }
    });
    modal.onWillDismiss<NextVisitReminder>().then((dismissData) => {
      if(dismissData && dismissData.role==='submit' && dismissData.data) {
        // this.reminderToEdit = dismissData.data;
        this.saveReminder(dismissData.data, 'Czy na pewno chcesz zmodyfikować zaproszenie na zaleconą wizytę?');
      }
    });
    return modal.present();
  }

  async duplicate(reminder: NextVisitReminder) {
    const nvr = new NextVisitReminder();
    nvr.aniName = reminder.aniName;
    nvr.doctorId = reminder.doctorId;
    nvr.doctorName = reminder.doctorName;
    nvr.isFlash = reminder.isFlash;
    nvr.isImportant = reminder.isImportant;
    nvr.petUUID = reminder.petUUID;
    nvr.userUUID = reminder.userUUID;
    nvr.visitType = reminder.visitType;
    nvr.vetcodeId = reminder.vetcodeId;
    nvr.vaccNextDate = reminder.vaccNextDate;
    nvr.vetineoVisitTypeBundleUUID = reminder.vetineoVisitTypeBundleUUID;
    nvr.vetDoctorVetVisitTypeUUID = reminder.vetDoctorVetVisitTypeUUID;
    nvr.vetineoVisitUUID = reminder.vetineoVisitUUID;


    const modal = await this.modalController.create({
      component: NextVisitReminderVisitTypeComponent,
      componentProps: {
        type: this.typeOfEdit,
        vetClinicStartContext: this.vetClinicStartContext,
        nextVisitReminder: nvr,
        clinicData: {...this.clinicData},
        nextVisitReminderSettings: this.nextVisitReminderSettings,
        title: 'Powiel zaleconą wizytę',
        isCopy: true
      }
    });
    modal.onWillDismiss<NextVisitReminder>().then((dismissData) => {
      if(dismissData && dismissData.role==='submit' && dismissData.data) {
        this.saveReminder(dismissData.data, 'Czy na pewno chcesz utworzyć nowe zaproszenie na zaleconą wizytę?');
      }
    });
    return modal.present();
  }

  delete(reminder: NextVisitReminder) {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz usunąć zaleconą wizytę?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      reminder.setToDelete = true;
      // this.reminderToEdit = null;
      reminder.created = null;
      reminder.modified = null;
      this.registerSubscription(this.nextVisitReminderService.editReminders([reminder]).subscribe(e => {
        if (e) {
          this.registerSubscription(this.nextVisitReminderService.getReminderForUser(reminder.userUUID, this.vetcodeId).subscribe(r => {
            this.nextVisitReminders = r;
            this.commonUtils.presentInfoToast('Usunięto zaleconą wizytę')
            this.appStateService.updateIsBusySubject(false);
          }, error => {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania zaleconej wizyty')
            this.appStateService.updateIsBusySubject(false);
          }));
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas usuwania zaleconej wizyty')
          this.appStateService.updateIsBusySubject(false);
        }
      }, error => {
        if(error.message == 'PET_IS_NOT_ALIVE'){
          this.commonUtils.presentAlertToast('Zwierze nie żyje, nie można edytować lub dodawać zaleconych wizyt');
          this.appStateService.updateIsBusySubject(false);
        } else {
          this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania zaleconej wizyty');
          this.appStateService.updateIsBusySubject(false);
        }
      }));
    }, () => {
    });
  }

  saveReminder(reminderToSave: NextVisitReminder, questionString: string) {
    if (this.checkReminder(reminderToSave)) {
      this.commonUtils.presentYesNoActionSheet(questionString, 'Tak', 'Nie', 'checkmark', 'close', () => {
        reminderToSave.vetcodeId = this.vetcodeId;
        reminderToSave.created = null;
        reminderToSave.modified = null;
        console.log(reminderToSave);
        this.registerSubscription(this.nextVisitReminderService.editReminders([reminderToSave]).subscribe(e => {
          if (e) {
            this.registerSubscription(this.nextVisitReminderService.getReminderForUser(reminderToSave.userUUID, this.vetcodeId).subscribe(r => {
              this.nextVisitReminders = r;
              console.log('po backend', this.nextVisitReminders);
              this.commonUtils.presentInfoToast('Zapisano zaproszenie na zaleconą wizytę');
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.commonUtils.presentInfoToast('Zapisano zaproszenie na zaleconą wizytę');
              this.appStateService.updateIsBusySubject(false);
            }))
          } else {
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania zaproszenia na zaleconą wizytę');
            this.appStateService.updateIsBusySubject(false);
          }
        }, error => {
          if(error.message == 'PET_IS_NOT_ALIVE'){
            this.commonUtils.presentAlertToast('Zwierze nie żyje, nie można edytować lub dodawać zaproszeń na zalecone wizyty');
            this.appStateService.updateIsBusySubject(false);
          } else {
            console.log(error.message);
            this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania zaproszenia na zaleconą wizytę');
            this.appStateService.updateIsBusySubject(false);
          }
        }));
      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Uzupełnij brakujące pola');
    }
  }

  checkReminder(reminder: NextVisitReminder) {

    return !(!reminder.scheduledFirstMessage || (!reminder.visitType && !reminder.vetineoVisitTypeBundleUUID));

  }

  checkCreatedReminder(reminder: NextVisitReminder) {
    return !(!reminder.scheduledFirstMessage || (!reminder.visitType && !reminder.vetineoVisitTypeBundleUUID) || !(reminder.petUUID || reminder.aniName));
  }

  cancelEdit() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz anulować edycję zaleconej wizyty?'
      , 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.reminderIsValid = true;
        // this.reminderToEdit = null;
        // this.createdReminder = null;
      },()=>{});
  }

  sendReminderNow(reminderToSend: NextVisitReminder) {
    if (this.checkCreatedReminder(reminderToSend)) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz przesłać zaproszenie do wizyty?'
        , 'Tak', 'Nie', 'checkmark', 'close', () => {
          this.appStateService.updateIsBusySubject(true);
          this.registerSubscription(this.nextVisitReminderService.sendFlashReminder(reminderToSend).subscribe(reminder => {
            this.appStateService.updateIsBusySubject(false);
            if (reminder) {
              if (reminder.sendFirstMessage) {
                this.registerSubscription(this.nextVisitReminderService.getReminderForUser(this.userUUID, this.vetcodeId).subscribe(r => {
                  this.nextVisitReminders = r;
                  // this.createdReminder = null;
                  this.commonUtils.presentInfoToast('Zaproszenie na wizytę zostało wysłane')
                  this.appStateService.updateIsBusySubject(false);
                }, error => {
                  this.commonUtils.presentInfoToast('Zaproszenie na wizytę zostało wysłane')
                  this.appStateService.updateIsBusySubject(false);
                }));
              } else {
                this.commonUtils.presentAlertToast('Wystąpił błąd podczas przesyłania zaproszenia')
              }
            } else {
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas przesyłania zaproszenia')
            }
          }, error => {
            if(error.message == 'PET_IS_NOT_ALIVE'){
              this.commonUtils.presentAlertToast('Zwierze nie żyje, nie można edytować lub dodawać powiadomień');
              this.appStateService.updateIsBusySubject(false);
            } else {
              this.commonUtils.presentAlertToast('Wystąpił błąd podczas zapisywania powiadomień');
              this.appStateService.updateIsBusySubject(false);
            }

          }));
        }, () => {
        })
    } else {

    }
  }

  async createReminder() {
    let nvr = new NextVisitReminder();
    nvr.idx = 0;
    nvr.vetcodeId = this.vetcodeId;
    // nvr.isFlash = true; // todo ta zmienna powinna teraz dotyczyc typu user | reservation
    nvr.userUUID = this.userUUID;

    const modal = await this.modalController.create({
      component: NextVisitReminderVisitTypeComponent,
      componentProps: {
        type: this.typeOfEdit,
        vetClinicStartContext: this.vetClinicStartContext,
        nextVisitReminder: nvr,
        clinicData: this.clinicData,
        nextVisitReminderSettings: this.nextVisitReminderSettings,
        title: 'Dodaj nową zaleconą wizytę'
      }
    });
    modal.onWillDismiss<NextVisitReminder>().then((dismissData) => {
      if(dismissData && dismissData.role==='submit' && dismissData.data) {
        console.log(dismissData.data);
        this.saveReminder(dismissData.data, 'Czy na pewno chcesz utworzyć nowe zaproszenie na zaleconą wizytę?');
      }
    });
    return modal.present();
  }

  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  async openMenu(ev: any, reminder: NextVisitReminder) {
    if (this.actionButtonsDef && this.actionButtonsDef.length > 1) {
      const popover = await this.popoverController.create({
        component: DataGridActionButtonsMenuComponent,
        componentProps: {
          'actionButtonsDef': this.actionButtonsDef,
          'data': reminder,
          standaloneMode: true
        },
        event: ev,
        translucent: true
      });
      await popover.present();

      const {role} = await popover.onDidDismiss();
    }
  }

  getVisitTypeDoctorNameString(reminder: NextVisitReminder) {
    const strings = [];
    if(reminder.visitType) {
      strings.push(reminder.visitType);
    }
    if (reminder.doctorName) {
      strings.push(reminder.doctorName);
    }
    return strings.length > 0 ? strings.join(' | ') : '';
  }

  getClinicName(clinic: VetClinic) {
    return this.clinicWithFullName ? this.commonUtils.getClinicNameWithAddress(clinic) : clinic.clinicName;
  }
}
